"use server";

import { query } from "@/lib/db";
import { queryTable, exportTable, type FaDetailRow, type TableFilters } from "@/lib/query";
import { FA_COLUMNS } from "./columns";

export async function fetchFaDetails(filters: TableFilters, page: number, pageSize: number) {
  return queryTable<FaDetailRow>("yhdmro_fa_fa_details", filters, page, pageSize);
}

export async function exportFaDetails(filters: TableFilters) {
  return exportTable("yhdmro_fa_fa_details", FA_COLUMNS, filters);
}

export async function fetchFaDetailById(id: number) {
  const result = await query(
    "SELECT * FROM yhdmro_fa_fa_details WHERE id = $1",
    [id]
  );
  return result.rows[0] as FaDetailRow & { row_json: string | null };
}